/**
 * 轻量稳定对比：用于大屏轮询。
 * - 对象键排序，避免字段顺序差异导致误判
 * - 跳过 Vue 的 __ob__
 * 整包未变则跳过赋值，避免图表无意义重绘。
 */
function normalize(value, seen) {
  if (value === null || typeof value !== "object") return value;
  if (seen.has(value)) return null;
  seen.add(value);
  if (Array.isArray(value)) {
    return value.map(v => normalize(v, seen));
  }
  const out = {};
  Object.keys(value)
    .filter(k => k !== "__ob__")
    .sort()
    .forEach(k => {
      out[k] = normalize(value[k], seen);
    });
  return out;
}

export function stableStringify(value) {
  try {
    return JSON.stringify(normalize(value, new WeakSet()));
  } catch (e) {
    return null;
  }
}

export function isSameJson(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  const sa = stableStringify(a);
  const sb = stableStringify(b);
  if (sa == null || sb == null) return false;
  return sa === sb;
}
